export default __webpack_public_path__ + "static/media/2.e869674c.png";